import type { CSSProperties, ReactNode } from 'react';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BrandS } from '@sorare/core/src/atoms/typography';

const StyledSection = styled(Vertical).attrs({ gap: 1.5 })`
  width: 100%;
`;

const SectionTitle = styled(BrandS)`
  display: flex;
  align-items: center;
  gap: var(--unit);
  & svg {
    color: var(--icon-color, currentColor);
  }
`;

type Props = {
  icon: ReactNode;
  iconColor?: string;
  title: ReactNode;
  children: ReactNode;
};

export const MissionSection = ({ icon, iconColor, title, children }: Props) => (
  <StyledSection>
    <SectionTitle
      style={
        iconColor ? ({ '--icon-color': iconColor } as CSSProperties) : undefined
      }
    >
      {icon}
      {title}
    </SectionTitle>
    {children}
  </StyledSection>
);
